import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'feinFormatter',
     
})
export class FeinPipe implements PipeTransform {
  transform(value: string): any {
    if (!value) {
      return '';
    }

    return `${value.substr(0, 2)}-${value.substr(2)}`;
  }
}
